<template>
  <div class="chat-page-wrapper">
    <div class="chat-top-strip">
      <div class="chat-top-inner">
        <div class="chat-top-center">
          <div class="chat-top-search">
            <el-input
              placeholder="搜索联系人/群/消息"
              v-model="topSearchText"
              clearable>
            </el-input>
          </div>
          <div v-if="isGlobalSearching" class="chat-global-search-panel" @click.stop>
            <template v-if="hasGlobalSearchResults">
              <div v-if="globalFriendResults.length" class="chat-global-search-block">
                <div class="chat-global-section-title">联系人</div>
                <div
                  v-for="friend in globalFriendResults"
                  :key="'gf-' + friend.id"
                  class="chat-global-row"
                  @click.stop="openFriendChat(friend)"
                >
                  <head-image :name="getFriendDisplayName(friend)" :url="friend.headImageThumb || friend.headImage" :size="34"></head-image>
                  <div class="chat-global-info">
                    <div class="chat-global-title">{{ getFriendDisplayName(friend) }}</div>
                    <div class="chat-global-subtitle">{{ friend.userName || '' }}</div>
                  </div>
                </div>
              </div>
              <div v-if="globalGroupResults.length" class="chat-global-search-block">
                <div class="chat-global-section-title">群聊</div>
                <div
                  v-for="group in globalGroupResults"
                  :key="'gg-' + group.id"
                  class="chat-global-row"
                  @click.stop="openGroupChat(group)"
                >
                  <head-image :name="getGroupDisplayName(group)" :url="group.headImageThumb || group.headImage" :size="34"></head-image>
                  <div class="chat-global-info">
                    <div class="chat-global-title">{{ getGroupDisplayName(group) }}</div>
                    <div class="chat-global-subtitle">群聊</div>
                  </div>
                </div>
              </div>
              <div v-if="globalMessageResults.length" class="chat-global-search-block">
                <div class="chat-global-section-title">消息</div>
                <div
                  v-for="item in globalMessageResults"
                  :key="'gm-' + item.key"
                  class="chat-global-row"
                  @click.stop="openChatFromSearch(item)"
                >
                  <head-image :name="item.title" :url="item.headImage" :size="34"></head-image>
                  <div class="chat-global-info">
                    <div class="chat-global-title">{{ item.title }}</div>
                    <div class="chat-global-subtitle">{{ item.content }}</div>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="chat-global-empty">暂无搜索结果</div>
          </div>
        </div>
      </div>
    </div>
    <el-container class="chat-page" :class="{ 'merged-forward-detail-open': mergedForwardDetailOpen }">
      <el-aside width="260px" class="aside">
        <div class="header">
          <div class="header-inner">
            <el-input
              class="search-text"
              size="small"
              placeholder="搜索联系人/群/消息"
              v-model="searchText">
              <i class="el-icon-search el-input__icon" slot="prefix"></i>
            </el-input>
            <div class="header-plus" @click.stop="showChatPlusMenu = !showChatPlusMenu">
              +
              <div v-if="showChatPlusMenu" class="header-plus-menu" @click.stop>
                <div class="menu-item" @click="openAddFriendDialog(); showChatPlusMenu = false">
                  <i class="el-icon-user"></i>
                  <span>添加好友</span>
                </div>
                <div class="menu-item" @click="openCreateGroupDialog(); showChatPlusMenu = false">
                  <i class="el-icon-chat-line-round"></i>
                  <span>发起群聊</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
          element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
        </div>
        <template v-else>
          <broadcast-item
            v-if="broadcastData.length > 0"
            :broadcast-data="broadcastData">
          </broadcast-item>
          <el-scrollbar class="chat-items">
            <div v-for="(chat, index) in chatStore.chats" :key="`${chat.type}-${chat.targetId}`">
              <chat-item v-show="matchesChatSearch(chat)" :chat="chat"
                :index="index" @click.native="onActiveItem(index)" @delete="onDelItem(index)" @top="onTop"
                :active="chat === chatStore.activeChat"></chat-item>
            </div>
          </el-scrollbar>
        </template>
      </el-aside>
      <el-container>
        <chat-box v-if="chatStore.activeChat" :chat="chatStore.activeChat"></chat-box>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import BroadcastItem from "../components/broadcast/BroadcastItem.vue";
import HeadImage from "../components/common/HeadImage.vue";
import friendStore from "../store/friendStore";
import groupStore from "../store/groupStore";
import chatStore from "../store/chatStore";
import { listLatestPublicMsgs } from "../api/publicMsg";

export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    BroadcastItem,
    HeadImage
  },
  data() {
    return {
      topSearchText: "",
      searchText: "",
      friendStore: friendStore(),
      groupStore: groupStore(),
      chatStore: chatStore(),
      messageContent: "",
      group: {},
      groupMembers: [],
      broadcastData: [],
      // 消息列表顶部 + 菜单显隐
      showChatPlusMenu: false,
      mergedForwardDetailOpen: false
    }
  },
  methods: {
    onActiveItem(index) {
      this.chatStore.setActiveChat(index);
      this.refreshPrivateChatFriendInfo(this.chatStore.activeChat);
    },
    refreshPrivateChatFriendInfo(chat) {
      if (!chat || chat.type !== 'PRIVATE' || !chat.targetId) return;
      this.$http({
        url: `/user/find/${chat.targetId}`,
        method: 'GET'
      }).then((userInfo) => {
        if (!userInfo || !userInfo.id) return;
        this.chatStore.updateChatFromFriend(userInfo);
        this.friendStore.updateFriend(userInfo);
      }).catch(() => {});
    },
    onDelItem(index) {
      this.chatStore.removeChat(index);
    },
    onTop(chat) {
      this.chatStore.toggleChatPin({ type: chat.type, targetId: chat.targetId });
    },
    normalizeSearchText(text) {
      return String(text || '').trim().toLowerCase();
    },
    matchesKeyword(values, keyword) {
      const normalizedKeyword = this.normalizeSearchText(keyword);
      if (!normalizedKeyword) return true;
      return values.some((value) => this.normalizeSearchText(value).includes(normalizedKeyword));
    },
    getFriendDisplayName(friend) {
      if (!friend) return '';
      try {
        const remarks = localStorage.getItem('friend_remarks');
        if (remarks) {
          const remarkMap = JSON.parse(remarks);
          if (remarkMap[friend.id]) return remarkMap[friend.id];
        }
      } catch (error) {
        console.error('获取备注失败:', error);
      }
      return friend.nickName || friend.userName || '';
    },
    getGroupDisplayName(group) {
      if (!group) return '';
      return group.showGroupName || group.name || '';
    },
    getChatTitle(chat) {
      if (!chat) return '';
      if (chat.type === 'PRIVATE') {
        const friend = this.friendStore.findFriend(chat.targetId);
        return this.getFriendDisplayName(friend) || chat.showName || chat.originalName || '';
      }
      if (chat.type === 'GROUP') {
        const group = this.groupStore.findGroup(chat.targetId);
        return this.getGroupDisplayName(group) || chat.showName || '';
      }
      return chat.showName || '';
    },
    getChatHeadImage(chat) {
      if (!chat) return '';
      if (chat.type === 'PRIVATE') {
        const friend = this.friendStore.findFriend(chat.targetId);
        return (friend && (friend.headImageThumb || friend.headImage)) || chat.headImage || '';
      }
      if (chat.type === 'GROUP') {
        const group = this.groupStore.findGroup(chat.targetId);
        return (group && (group.headImageThumb || group.headImage)) || chat.headImage || '';
      }
      return chat.headImage || '';
    },
    formatSearchMessageContent(message) {
      if (!message || !message.content) return '';
      return String(message.content).replace(/\s+/g, ' ').trim();
    },
    matchesChatSearch(chat) {
      if (!chat || chat.delete) return false;
      const keyword = this.normalizeSearchText(this.searchText);
      if (!keyword) return true;
      const values = [
        chat.showName,
        chat.originalName,
        chat.lastContent,
        chat.sendNickName
      ];
      if (chat.messages) {
        chat.messages.forEach((message) => {
          values.push(message && message.content);
          values.push(message && message.sendNickName);
        });
      }
      return values.some((value) => this.normalizeSearchText(value).includes(keyword));
    },
    openFriendChat(friend) {
      if (!friend) return;
      this.chatStore.openChat({
        type: "PRIVATE",
        targetId: friend.id,
        showName: friend.nickName || friend.userName,
        headImage: friend.headImageThumb || friend.headImage,
      });
      this.chatStore.setActiveChat(0);
      this.topSearchText = "";
    },
    openGroupChat(group) {
      if (!group) return;
      this.chatStore.openChat({
        type: "GROUP",
        targetId: group.id,
        showName: group.showGroupName || group.name,
        headImage: group.headImageThumb || group.headImage,
      });
      this.chatStore.setActiveChat(0);
      this.topSearchText = "";
    },
    openChatFromSearch(item) {
      if (!item || !item.chat) return;
      const chat = item.chat;
      if (chat.type === 'GROUP') {
        const group = this.groupStore.findGroup(chat.targetId) || {
          id: chat.targetId,
          showGroupName: item.title,
          headImageThumb: item.headImage,
        };
        this.openGroupChat(group);
        return;
      }
      const friend = this.friendStore.findFriend(chat.targetId) || {
        id: chat.targetId,
        nickName: item.title,
        headImageThumb: item.headImage,
      };
      this.openFriendChat(friend);
    },
    openCreateGroupDialog() {
      this.$router.push({
        path: "/home/group",
        query: { create: '1', t: Date.now() }
      });
    },
    goToFriendRequest() {
      this.$router.push("/home/friend-request");
    },
    openAddFriendDialog() {
      this.$router.push({
        path: "/home/friend",
        query: { addFriend: '1', t: Date.now() }
      });
    },
    loadBroadcastData() {
      listLatestPublicMsgs()
        .then((result) => {
          this.broadcastData = Array.isArray(result) ? result : [];
        })
        .catch(() => {
          this.broadcastData = [];
        });
    },
    // 点击页面其它区域时关闭左侧 + 菜单
    handleGlobalClick() {
      if (this.showChatPlusMenu) {
        this.showChatPlusMenu = false;
      }
    },
    onMergedForwardDetailVisible(visible) {
      this.mergedForwardDetailOpen = !!visible;
    },
  },
  mounted() {
    // 刷新所有聊天的显示名称
    this.chatStore.refreshAllChatDisplayNames();
    this.loadBroadcastData();
    // 监听全局点击和右键，点击其它区域时关闭 + 菜单
    document.addEventListener('click', this.handleGlobalClick);
    document.addEventListener('contextmenu', this.handleGlobalClick);
    this.$eventBus.$on('mergedForwardDetailVisible', this.onMergedForwardDetailVisible);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleGlobalClick);
    document.removeEventListener('contextmenu', this.handleGlobalClick);
    this.$eventBus.$off('mergedForwardDetailVisible', this.onMergedForwardDetailVisible);
  },
  computed: {
    globalSearchKeyword() {
      return (this.topSearchText || '').trim();
    },
    isGlobalSearching() {
      return !!this.globalSearchKeyword;
    },
    globalFriendResults() {
      const keyword = this.globalSearchKeyword;
      if (!keyword) return [];
      return (this.friendStore.friends || []).filter((friend) => {
        if (friend.deleted) return false;
        return this.matchesKeyword([
          this.getFriendDisplayName(friend),
          friend.nickName,
          friend.userName,
          friend.remarkNickName
        ], keyword);
      }).slice(0, 10);
    },
    globalGroupResults() {
      const keyword = this.globalSearchKeyword;
      if (!keyword) return [];
      return (this.groupStore.groups || []).filter((group) => {
        if (group.quit) return false;
        return this.matchesKeyword([
          this.getGroupDisplayName(group),
          group.showGroupName,
          group.name
        ], keyword);
      }).slice(0, 10);
    },
    globalMessageResults() {
      const keyword = this.globalSearchKeyword;
      if (!keyword) return [];
      const results = [];
      const chats = this.chatStore.findChats ? this.chatStore.findChats() : [];
      (chats || []).forEach((chat) => {
        if (!chat || chat.delete || !chat.messages) return;
        const title = this.getChatTitle(chat);
        const headImage = this.getChatHeadImage(chat);
        chat.messages.forEach((message, index) => {
          const content = this.formatSearchMessageContent(message);
          if (!content || !this.matchesKeyword([content], keyword)) return;
          results.push({
            key: `${chat.type}-${chat.targetId}-${message.id || message.tmpId || index}`,
            chat,
            title,
            headImage,
            content
          });
        });
      });
      return results.slice(0, 30);
    },
    hasGlobalSearchResults() {
      return this.globalFriendResults.length || this.globalGroupResults.length || this.globalMessageResults.length;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-page-wrapper {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.chat-top-strip {
  height: 48px;
  background: #e1e6f0; // 与 Home.vue 左侧导航保持一致
  display: flex;
  align-items: center;
}

.chat-top-inner {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 32px;
  box-sizing: border-box;
}

.chat-top-center {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  left: -120px; // 略向左偏，与 im-oa 视觉保持一致
}

.chat-top-search {
  width: clamp(480px, calc(480px + (100vw - 1440px) * 0.6667), 960px);
  min-width: 480px;
  max-width: calc(100vw - 64px);
}

.chat-global-search-panel {
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  max-height: calc(100vh - 92px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 10px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.14);
  z-index: 3000;
}

.chat-global-search-block {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.chat-global-section-title {
  padding: 4px 2px 6px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}

.chat-global-row {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 7px 6px;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #f5f7fa;
  }
}

.chat-global-info {
  flex: 1;
  min-width: 0;
}

.chat-global-title {
  font-size: 14px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-global-subtitle {
  margin-top: 4px;
  font-size: 12px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-global-empty {
  padding: 28px 0;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
}

.chat-page {
  position: relative;
  z-index: 1;
  height: calc(100vh - 48px);
  background: #ffffff;

  .el-aside.aside {
    position: relative;
    z-index: 100;
    display: flex;
    flex-direction: column;
    background: var(--im-background);
    border-right: 1px solid #e5e5e5;
    padding-top: 0;
    overflow: visible; // 允许 + 菜单溢出到中间区域

    .header {
      padding: 10px 10px 8px 10px;
      position: relative;

      .header-inner {
        display: flex;
        align-items: center;
      }

      .search-text {
        flex: 1;
        min-width: 0;
      }

      .header-plus {
        position: relative;
        margin-left: 6px;
        width: 26px;
        height: 26px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        border: 1px solid #d0d5e5;
        cursor: pointer;
        font-size: 18px;
        color: #666;
        background: #f7f8fc;
        transition: all 0.2s;
      }

      .header-plus:hover {
        color: #1976d2;
        border-color: #1976d2;
      }

      .header-plus-menu {
        position: absolute;
        top: 34px; // 稍微下移一点
        right: 0;  // 右边缘对齐左侧列表区域分割线，和通讯录页面保持一致
        width: 140px;
        background: #ffffff;
        box-shadow: var(--im-box-shadow-light);
        border-radius: 6px;
        padding: 6px 0;
        z-index: 2000; // 确保浮在中间内容之上
      }

      .header-plus-menu .menu-item {
        padding: 6px 12px;
        font-size: var(--im-font-size-small);
        color: var(--im-text-color);
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .header-plus-menu .menu-item:hover {
        background: #f5f7fa;
      }
    }

    // 中间内容容器层级保持较低，避免盖住左侧菜单
    + .el-container {
      position: relative;
      z-index: 0;
    }

    .chat-loading {
      height: 50px;
      background: transparent;
      color: #9ca3af;

      .el-icon-loading {
        font-size: 24px;
        color: #9ca3af;
      }

      .el-loading-text {
        color: #9ca3af;
      }
    }

    .chat-items {
      flex: 1;
      padding: 6px 4px 8px 4px;
    }
  }
}

.chat-page.merged-forward-detail-open .el-aside.aside + .el-container {
  position: relative;
  z-index: 300;
}
</style>
